import {
  BuyParams,
  createFormatters,
  createHrefs,
  createMachine,
  createUtm,
  withParams,
} from "@indietabletop/appkit";
import { client } from "../client";
import { database } from "../database-provider";

export const machine = createMachine({
  database: database,
  client,
  pullGameDataFor: ["hobgoblin"],
});

export const utm = createUtm({
  source: "indietabletopclub",
  medium: "referral",
  campaign: "hobgoblin_app",
});

export const hrefs = createHrefs({
  utm,
  hrefs: {
    account: () => `~/account`,
    buy: (params?: BuyParams) => withParams(`~/rules`, params),
    rules: () => `~/rules`,
    quickStartRules: () => `~/rules/quick-start`,
    builder: () => `~/armies`,
    about: () => `~/help/about`,
  },
});

export const fmt = createFormatters("en-GB");
